import { SPACING } from "~/styles/variables";
import CertifiedFieldFormValue from "../ReusableFormValues/CertifiedFieldFormValue";
import DescriptionOnlyFormValues from "../ReusableFormValues/DescriptionOnlyFormValues";
import SubTypeDocumentSelector from "../SubTypeDocumentSelector";
import { shareRegisterDocumentTypesArray } from "./constants";

export type Props = {
  readonly: boolean;
  documentName?: string;
};

const ShareRegisterFormValues = ({ readonly, documentName = "" }: Props) => {
  return (
    <>
      <SubTypeDocumentSelector
        readonly={readonly}
        subTypeDocuments={shareRegisterDocumentTypesArray}
        placeholder="Select a share register document type"
        name="secondaryDocumentType"
        label="Document sub-type"
        documentName={documentName}
      />
      <div style={{ marginBottom: SPACING.SMALL }}>
        <DescriptionOnlyFormValues readonly={readonly} />
      </div>
      <div style={{ marginBottom: SPACING.SMALL }}>
        <CertifiedFieldFormValue readonly={readonly} />
      </div>
    </>
  );
};

export default ShareRegisterFormValues;
